import React from "react";

const CamLoading = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="33.5913"
        cy="37.8174"
        r="2.38916"
        transform="rotate(-180 33.5913 37.8174)"
        fill="#757575"
      />
      <circle
        cx="24.9917"
        cy="37.8174"
        r="2.38916"
        transform="rotate(-180 24.9917 37.8174)"
        fill="#454545"
      />
      <circle
        cx="16.3921"
        cy="37.8174"
        r="2.38916"
        transform="rotate(-180 16.3921 37.8174)"
        fill="#353535"
      />
      <rect
        x="15"
        y="18.3525"
        width="13.01"
        height="9.39609"
        rx="1.08416"
        fill="#7B7B7B"
      />
      <path
        d="M28.3713 23.6768C27.8894 23.3986 27.8894 22.7031 28.3713 22.4249L34.3342 18.9822C34.816 18.704 35.4183 19.0518 35.4183 19.6082L35.4183 26.4935C35.4183 27.0499 34.816 27.3977 34.3342 27.1195L28.3713 23.6768Z"
        fill="#7B7B7B"
      />
    </svg>
  );
};

export default CamLoading;
